import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";

import { maintenanceNotice } from "../maintenance/notice";
import type { MaintenanceNotice } from "../maintenance/notice";
import { retryDelay, shouldRetry } from "./retry";

const THIRTY_SECONDS = 30_000;

type QueryClientOptions = {
  /** Called when any query or command is refused because the app is held for maintenance. */
  readonly onMaintenance?: (notice: MaintenanceNotice) => void;
};

/** The one QueryClient setup every console shares. Commands (mutations) are never retried. */
export function createQueryClient({ onMaintenance }: QueryClientOptions = {}): QueryClient {
  const noteMaintenance = (error: unknown) => {
    const notice = maintenanceNotice(error);
    if (notice) onMaintenance?.(notice);
  };
  return new QueryClient({
    queryCache: new QueryCache({ onError: noteMaintenance }),
    mutationCache: new MutationCache({ onError: noteMaintenance }),
    defaultOptions: {
      queries: {
        staleTime: THIRTY_SECONDS,
        refetchOnWindowFocus: false,
        retry: shouldRetry,
        retryDelay,
      },
      mutations: { retry: false },
    },
  });
}
